export const filtersList = [
  'Asset',
  'Asset class',
  'Industry',
  'Currency',
  'Country',
] as const;

export type FilterType = typeof filtersList[number];

export const rowList = [
  'My portfolio',
  'S&P 500',
  'Dow Jones',
  'NASDAQ',
  'Eurostoxx50',
  'Hang Seng',
];
